import { Ambiente } from "../model/ambiente.model";
import { AtoRecurso } from "../model/ato-recurso.model";
import { Recurso } from "../model/recurso.model";

export class BancoRecursos {
    ambiente: Ambiente;
    recursosNormas: AtoRecurso[] = [];
    recursosInternet: Recurso[] = [];

    constructor(ambiente: Ambiente) {
        this.ambiente = ambiente;
    }

    obterAtoRecursoNormas(idAto: number): AtoRecurso | null {
        const found = this.recursosNormas.find(a => a.idAto == idAto);
        return found ? found : null;
    }

    incluirAtoRecursoNormas(a: AtoRecurso) {
        const found = this.obterAtoRecursoNormas(a.idAto);
        if (found) {
            this.recursosNormas.splice(this.recursosNormas.indexOf(found), 1);
        }
        this.recursosNormas.push(a);
    }

    obterRecursoInternet(url: string): Recurso | null {
        const split = url.split('#');
        const found = this.recursosInternet.find(ri => ri.url == split[0]);
        return found ? found : null;
    }

    incluirRecursoInternet(r: Recurso) {
        const found = this.obterRecursoInternet(r.url);
        if (found) {
            this.recursosInternet.splice(this.recursosInternet.indexOf(found), 1);
        }
        this.recursosInternet.push(r);
    }

    obterUrlNormasInterno(idAto: number): string {
        return this.ambiente.urlConsultaInterna.replace('{idAto}', '' + idAto);
    }

    obterUrlNormasExterno(idAto: number): string {
        return this.ambiente.urlConsultaExterna.replace('{idAto}', '' + idAto);
    }

    /**
     * Ordena os fragmentos de um recurso por dispositivo (ordenação alfanumérica), com a exceção do fragmento 'integra', que sempre vem primeiro.
     * @param recurso O recurso contendo os fragmentos a serem ordenados.
     */
    ordenarFragmentosPorDispositivo(recurso: Recurso) {
        recurso.fragmentos.sort((a, b) => {
            if (a.dispositivo === 'íntegra' && b.dispositivo !== 'íntegra') {
                return -1;
            }
            if (b.dispositivo === 'íntegra' && a.dispositivo !== 'íntegra') {
                return 1;
            }
            return a.dispositivo.localeCompare(b.dispositivo, 'pt', { numeric: true });
        });
    }
}
